import type { IconProps } from './types';

export const UploadCloud02Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M17.625 17.625C20.2138 17.625 22.3125 15.5263 22.3125 12.9375C22.3125 10.3487 20.2138 8.25 17.625 8.25C17.625 5.1434 15.1066 2.625 12 2.625C9.53784 2.625 7.44516 4.20693 6.68288 6.40985C3.87263 6.72284 1.6875 9.10624 1.6875 12C1.6875 14.7872 3.71465 17.1009 6.375 17.5472"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M15.75 16.6875L12 12.9375L8.25 16.6875" stroke={color} strokeWidth="1.5" />
      <path d="M12 22.3125V12.9375" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
